import React from 'react';
import history from "utils/history";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import storage from "utils/Storage";
import { encode, Event } from 'utils/Helper';
import socket from "utils/Socket";
import C from 'utils/Constant';
import styled from 'styled-components';
import { LogOut } from 'lucide-react';

const Logout = () => {

    const ask = () => {
        const styleId = "stake-logout-swal-styles";
        // Always remove and re-inject to ensure latest styles apply
        const existingTag = document.getElementById(styleId);
        if (existingTag) existingTag.remove();
        let styleTag = document.createElement("style");
            styleTag.id = styleId;
            styleTag.innerHTML = `
                .swal2-popup.stake-logout-popup {
                    background: linear-gradient(135deg, #16252D 0%, #0f1f2a 100%) !important;
                    border: 1px solid rgba(255,255,255,0.08) !important;
                    border-radius: 16px !important;
                    padding: 28px 24px !important;
                    max-width: 360px !important;
                    width: calc(100vw - 40px) !important;
                    box-shadow: 0 24px 60px rgba(0,0,0,0.7) !important;
                }
                .swal2-popup.stake-logout-popup .swal2-icon {
                    width: 48px !important;
                    height: 48px !important;
                    margin: 0 auto 16px !important;
                }
                .swal2-popup.stake-logout-popup .swal2-icon .swal2-icon-content {
                    font-size: 28px !important;
                }
                .swal2-popup.stake-logout-popup .swal2-title {
                    font-size: 18px !important;
                    color: #fff !important;
                    font-weight: 700 !important;
                    padding: 0 !important;
                    margin-bottom: 8px !important;
                }
                .swal2-popup.stake-logout-popup .swal2-html-container {
                    font-size: 13px !important;
                    color: #b1bad3 !important;
                    margin: 0 0 20px !important;
                    line-height: 1.6 !important;
                }
                .swal2-popup.stake-logout-popup .swal2-actions {
                    display: flex !important;
                    flex-direction: row !important;
                    flex-wrap: nowrap !important;
                    gap: 10px !important;
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    justify-content: stretch !important;
                    align-items: center !important;
                }
                .swal2-popup.stake-logout-popup .swal2-cancel,
                .swal2-popup.stake-logout-popup .swal2-confirm {
                    flex: 1 !important;
                    width: 50% !important;
                    min-width: 0 !important;
                    margin: 0 !important;
                    padding: 0 8px !important;
                    height: 40px !important;
                    border-radius: 8px !important;
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    box-shadow: none !important;
                    border: none !important;
                    box-sizing: border-box !important;
                }
                .swal2-popup.stake-logout-popup .swal2-cancel {
                    background: #2f4553 !important;
                    color: #fff !important;
                }
                .swal2-popup.stake-logout-popup .swal2-cancel:hover {
                    background: #3a5468 !important;
                }
                .swal2-popup.stake-logout-popup .swal2-confirm {
                    background: #1475e1 !important;
                    background-image: none !important;
                    color: #fff !important;
                }
                .swal2-popup.stake-logout-popup .swal2-confirm:hover {
                    background: #1880f0 !important;
                }
                .swal2-backdrop-show {
                    background: rgba(0,0,0,0.75) !important;
                    backdrop-filter: blur(4px) !important;
                }
            `;
            document.head.appendChild(styleTag);

        Swal.fire({
            title: 'Signing Out',
            text: "Are you sure you want to log out? Check our great promotions and bonuses before you leave!",
            icon: 'warning',
            showCancelButton: true,
            customClass: {
                popup: 'stake-logout-popup'
            },
            cancelButtonColor: '#2f4553',
            confirmButtonColor: '#1475e1',
            confirmButtonText: 'Logout',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                socket.emit(C.LOGOUT_USER);
                localStorage.clear();
                Cookies.remove("session");
                Cookies.remove("auth");
                Cookies.remove("uid");
                socket.io.opts.query = { auth_token: null, user_key: null };
                socket.disconnect();
                socket.connect();
                Event.emit("logout");
                history.push('/');
            }
        });
    };

    return (
        <div onClick={ask} style={{ width: "100%" }}>
            <div className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-[#ff4d4d]/10 hover:text-[#ff4d4d] text-[#8e969f] font-semibold text-sm transition-all duration-150 w-full cursor-pointer">
                <LogOut size={18} className="shrink-0" />
                <span>Logout</span>
            </div>
        </div>
    );
};

export default Logout;
